import { render, staticRenderFns } from "./ComplianceExpiredWidget.vue?vue&type=template&id=7d1dbe69&lang=pug"
import script from "./ComplianceExpiredWidget.vue?vue&type=script&lang=ts"
export * from "./ComplianceExpiredWidget.vue?vue&type=script&lang=ts"
import style0 from "./ComplianceExpiredWidget.vue?vue&type=style&index=0&id=7d1dbe69&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports